import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Location } from 'types';

export const getLocationByAnalyzer = async (
  analyzerId: number
): Promise<Location> => {
  const { data }: { data: Location } = await axios.get(
    `/api/locations/analyzer/${analyzerId}`
  );
  return data as Location;
};

type QueryFnType = typeof getLocationByAnalyzer;

type UseLocationByAnalyzerOptions = {
  analyzerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useLocationByAnalyzer = ({
  analyzerId,
  config,
}: UseLocationByAnalyzerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['locations', 'analyzers', analyzerId],
    queryFn: () => getLocationByAnalyzer(analyzerId),
    ...config,
  });
};
